import { render, staticRenderFns } from "./StudentCourses.vue?vue&type=template&id=83d15b62"
import script from "./StudentCourses.vue?vue&type=script&lang=js"
export * from "./StudentCourses.vue?vue&type=script&lang=js"
import style0 from "./StudentCourses.vue?vue&type=style&index=0&id=83d15b62&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports